import { useLayoutEffect, useRef } from 'react';

const usePageTitle = (title: string) => {
    useLayoutEffect(() => {
        if (!title) return;
        document.title = title;
    }, [title]);
};

export default usePageTitle;
